import type { ReactNode } from "react";

/** OWNED BY C1. The 4-item bottom tab bar (U-005). */
export interface TabItem<T extends string> {
  id: T;
  label: string;
  glyph: ReactNode;
}

export function TabBar<T extends string>({ items, active, onChange }: {
  items: ReadonlyArray<TabItem<T>>;
  active: T;
  onChange: (id: T) => void;
}) {
  return (
    <nav className="wc-tabbar" aria-label="Sections">
      {items.map((it) => (
        <button
          key={it.id}
          type="button"
          className="wc-tabbar__btn"
          aria-current={it.id === active ? "page" : undefined}
          onClick={() => onChange(it.id)}
        >
          <span className="wc-tabbar__glyph" aria-hidden="true">{it.glyph}</span>
          {it.label}
        </button>
      ))}
    </nav>
  );
}
